<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="商品搜索：" prop="name">
          <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称搜索"></el-input>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          <el-button type="primary" style="margin-left: 40px;" @click="goodsOpenBtn">添加商品</el-button>
        </el-form-item>
      </el-form>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="折扣商品">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsThumb"
            label="商品图片">
            <template slot-scope="scope">
              <el-image
                class="mt-table-goods-img"
                :src="scope.row.goodsThumb == null ? imgServer+'no_img.png' : scope.row.goodsThumb"
                :preview-src-list="[scope.row.goodsThumb]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsSpecPrice"
            label="商品金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 选择商品弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsShow"
      width="960px">
      <el-form :model="goodsSearchForm" inline ref="goodsSearchForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="商品名称：" prop="name">
          <el-input class="mt-search-width" v-model="goodsSearchForm.name" placeholder="请输入商品名称"></el-input>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        border
        :data="goodsInfoList"
        @selection-change="goodsHandleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecId"
          label="ID">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecThumb"
          label="商品图">
          <template slot-scope="scope">
            <el-image
              style="width: 40px;"
              :src="scope.row.goodsSpecThumb"
              :preview-src-list="[scope.row.goodsSpecThumb]"
              fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsName"
          label="商品名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecName"
          label="商品规格">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecPrice"
          label="商品价格">
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="goodsPageTotal" :page="goodsCurrentPage" :limit="goodsLimitLength" @pagination="goodsHandleCurrentChange" />
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="goodsSureBtn">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { queryDiscountGoodsPageList, removeDiscountGoodsById, saveDiscountGoods, goodsListInfo } from '@/api/discount'
export default {
  name: 'DiscountGoodsList',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 选择商品弹窗
      goodsShow:false,
      goodsInfoList: [],
      goodsPageTotal: 0,
      goodsCurrentPage: 1,
      goodsLimitLength: this.$limitLength,
      goodsSearchForm: {
        name:''
      },
      multipleSelection:[]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let dataId = that.dataId;
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryDiscountGoodsPageList({ discountActivityId: dataId, webSearchStr: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 选择商品弹窗-打开弹窗
    goodsOpenBtn(){
      this.goodsGetInfoList();
      this.goodsShow = true;
    },
    /* 选择商品弹窗-搜索操作 */
    goodsSearchTopBtn(){
      this.goodsCurrentPage = 1;
      this.goodsGetInfoList();
    },
    // 选择商品弹窗-选择商品操作
    goodsHandleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 选择商品弹窗-确认选择
    goodsSureBtn(){
      var multipleSelection = this.multipleSelection;
      if(multipleSelection.length == 0){
        this.$message.error('请选择商品');
        return false;
      }
      var goodsSpecIdList = [];
      multipleSelection.forEach(function(item){
        goodsSpecIdList.push(item.goodsSpecId);
      });
      var that = this;
      saveDiscountGoods({ discountActivityId: that.dataId, goodsSpecIdList: goodsSpecIdList }).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.goodsShow = false;
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    // 选择商品弹窗-获取数据
    goodsGetInfoList () {
      let that = this
      let searchName = that.goodsSearchForm.name
      let page = that.goodsCurrentPage
      goodsListInfo({ goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.goodsInfoList = data
          that.goodsPageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.goodsInfoList = []
          that.goodsPageTotal = res.total
        }
      })
    },
    // 选择商品弹窗-当前页码操作
    goodsHandleCurrentChange (val) {
      this.goodsCurrentPage = val
      this.goodsGetInfoList()
    },
    // 选择商品弹窗-当前页码操作
    goodsHandleCurrentChange(val){
      this.goodsCurrentPage = val.page;
      this.goodsLimitLength = val.limit;
      this.goodsGetInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeDiscountGoodsById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/discount/GoodsList.vue